module.exports = __webpack_public_path__ + "static/media/livestock_output_2.a7d53f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LivestockIdxTool/livestock_output_2.png
// module id = 1790
// module chunks = 0